// import axios from "axios";

// const API_BASE = process.env.REACT_APP_PRODUCT_SERVICE_URL;

// export async function fetchProducts(page = 0, size = 20) {
//   const res = await axios.get(`${API_BASE}/products/admin`, {
//     params: { page, size, sortBy: "createdAt", direction: "DESC" },
//   });
//   return res.data;
// }

// // Approve a product
// export async function approveProduct(productId, moderatorId) {
//   return axios.put(`${API_BASE}/products/${productId}/moderate`, {
//     status: "APPROVED",
//     reason: "Approved by moderator",
//     moderatorId,
//   });
// }

// // Reject a product with a reason
// export async function rejectProduct(productId, reason, moderatorId) {
//   return axios.put(`${API_BASE}/products/${productId}/moderate`, {
//     status: "REJECTED",
//     reason,
//     moderatorId,
//   });
// }

import axiosClient from "./axiosClient";

// Fetch products
export async function fetchProducts(page = 0, size = 20) {
  const res = await axiosClient.get("/products/admin", {
    params: { page, size, sortBy: "createdAt", direction: "DESC" },
  });
  return res.data;
}

// Approve product
export async function approveProduct(productId, moderatorId) {
  return axiosClient.put(`/products/${productId}/moderate`, {
    status: "APPROVED",
    reason: "Approved by moderator",
    moderatorId,
  });
}

// Reject product
export async function rejectProduct(productId, reason, moderatorId) {
  return axiosClient.put(`/products/${productId}/moderate`, {
    status: "REJECTED",
    reason,
    moderatorId,
  });
}
